"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVALID_PASSPORT_DATE = void 0;
exports.INVALID_PASSPORT_DATE = '1997-09-30';
